"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgComprass(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M6.436 19.411a.75.75 0 01.449.878l-.031.097-1.157 2.893a.75.75 0 01-1.425-.46l.032-.097 1.157-2.893a.75.75 0 01.975-.418zM12 .25a.75.75 0 01.743.648l.007.102v2.354a2.752 2.752 0 011.079 4.7l5.866 14.667a.75.75 0 01-1.348.65l-.044-.092-2.284-5.713c-1.264.784-2.742 1.184-4.343 1.184-4.66 0-8.425-3.925-8.427-8.75a.75.75 0 011.5 0c.001 2.212.947 4.189 2.435 5.518l2.986-7.465a2.751 2.751 0 011.08-4.7V1a.75.75 0 01.75-.75zm.475 8.459a2.765 2.765 0 01-.952 0l-3.08 7.703a6.65 6.65 0 003.233.838c1.425 0 2.708-.375 3.775-1.103zm-.475-3.959a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgComprass;
exports.default = _default;